import { toast } from 'sonner';

/**
 * Delete with an Undo toast. The row is hidden at once (`hide`) and the real
 * delete runs when the toast goes away without Undo; Undo calls `restore`.
 */
export function withUndo({ message, hide, restore, commit }: { message: string; hide: () => void; restore: () => void; commit: () => void }) {
  let undone = false;
  hide();
  toast(message, {
    duration: 4000,
    action: {
      label: 'Undo',
      onClick: () => {
        undone = true;
        restore();
      }
    },
    onAutoClose: () => {
      if (!undone) commit();
    },
    onDismiss: () => {
      if (!undone) commit();
    }
  });
}
